




























































































































































































































import Vue from 'vue'
import { Gender } from '@/data/enums'
import Component from 'vue-class-component'
import { getOpticianData, setConfig } from '@/api/rodenstock'
import { getModule } from 'vuex-module-decorators'
import BaseModal from './components/ui/BaseModal.vue'
import ShoppingCart from './components/ShoppingCart.vue'
import SideBar from './components/SideBar.vue'
import Cart from './store/modules/cart'
import Optician from './store/modules/data'
import './icons/arrow'
import './icons/arrow-circle'
import './icons/close'
import './icons/home'
import './icons/info'
import './icons/logo'
import './icons/profile'
import './icons/profile-male'
import './icons/profile-female'
import './icons/save'
import DefaultButton from '@/components/ui/DefaultButton.vue'
import ScreenSaver from '@/components/ScreenSaver.vue'
import { AxiosResponse } from 'axios'
getModule(Cart)
getModule(Optician)

@Component({
  components: {
    DefaultButton,
    BaseModal,
    ShoppingCart,
    SideBar,
    ScreenSaver
  },
  computed: {
    profileName: {
      get () {
        return this.$store.state.matrix.name
      },
      set (value) {
        this.$store.dispatch('matrix/setName', value)
          .catch((err) => console.error(err))
      }
    }

  }
})
export default class App extends Vue {
  public dataPromise: Promise<any> | undefined
  private message: string = ''
  private dataReady: boolean = false
  private error: boolean = false
  private showGoHome: boolean = false
  private showSaveProfile: boolean = false
  private sidebarOpen: boolean = false
  private shoppingCartOpen: boolean = false
  private currentOcode: string = ''
  private offlineMode: string = ''
  private zoom: number = 1

  private get showProfile () {
    return this.$route.fullPath.indexOf('/profile') !== -1
  }
  private get age () {
    return this.$store.state.matrix.age
  }

  private get clientName () {
    return this.$store.state.matrix.name
  }

  private get gender () {
    return (this.$store.getters['matrix/gender'] === Gender.Female)
      ? 'gender_female'
      : 'gender_male'
  }

  private get isMale () {
    return (this.$store.getters['matrix/gender'] !== Gender.Female)
  }

  private get oCode (): string {
    const code = this.$store.state.oCode
    if (!this.dataReady) {
      this.getOpticianData(code)
    }
    return code
  }

  private get hasLogo (): boolean {
    const image = this.$store.state.data.optician.logo
    return image
  }

  private get logo (): string {
    if (this.hasLogo) {
      if (!this.$store.state.offlineMode) {
        return this.$config.url + 'upload/' + this.$store.state.data.optician.logo
      } else {
        return 'upload/' + this.$store.state.data.optician.logo
      }
    }
    return ''
  }

  private get debug () {
    return this.$store.state.debug
  }

  private get mode (): string {
    if (this.$store.state.offlineMode) {
      return 'offline'
    }
    return 'online'
  }

  private get routeParams () {
    return this.$store.state.route.query
  }

  private setGenderMale () {
    this.$store.dispatch('matrix/setGender', Gender.Male).catch((err) => console.error(err))
  }
  private setGenderFemale () {
    this.$store.dispatch('matrix/setGender', Gender.Female).catch((err) => console.error(err))
  }

  private onResize () {
    const sw = window.innerWidth
    const mw = 1920
    if (sw < mw) {
      this.zoom = sw / mw
    } else {
      this.zoom = 1
    }
    if (this.zoom > 1) {
      this.zoom = 1
    }
    document.documentElement.style.zoom = this.zoom.toString()
  }

  private getOpticianData (code: string) {
    this.dataPromise = new Promise((resolve, reject) => {
      getOpticianData(code, this.$store.state.offlineMode)
        .then((response: AxiosResponse) => {
          resolve(response.data)
        })
        .catch((err) => reject(err))
    })
  }

  private beforeMount () {
    setConfig(this.$config)
    this.processRoute()
    if (!this.oCode) return
    this.getOpticianData(this.oCode)
    this.currentOcode = this.oCode
    this.offlineMode = this.mode
  }

  private beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }

  private mounted () {
    window.addEventListener('resize', this.onResize)
    this.onResize()
    if (this.dataPromise) {
      this.dataPromise
        .then(async (result) => {
          try {
            await this.$store.dispatch('data/setJson', result)
            await this.$store.dispatch('matrix/init')
            this.dataReady = true

            // set initial gender
            if (this.$store.state.data.optician.initialGender === 1) {
              this.setGenderFemale()
            } else {
              this.setGenderMale()
            }
          } catch (err) {
            this.message = err
            this.error = true
          }
        })
        .catch((err) => {
          this.message = err
          this.error = true
        })
    }
  }

  private processRoute () {
    const mutationParams = {
      debug: 'setDebugMode',
      offline: 'setOfflineMode',
      ocode: 'setOpticianCode'
    }
    const routeParams = this.routeParams
    for (const [key, value] of Object.entries(mutationParams)) {
      if (routeParams.hasOwnProperty(key)) {
        this.$store.dispatch(value, (routeParams[key]))
          .catch((err) => console.error('err', err))
      }
    }
  }

  private goHome (clearProfile: boolean) {
    if (clearProfile) {
      let resetGender = Gender.Male
      if (this.$store.state.data.optician.initialGender === 1) {
        resetGender = Gender.Female
      }

      this.showGoHome = false
      this.$store.dispatch('cart/clear')
        .catch((err) => console.error(err))
      this.$store.dispatch('matrix/clearProfile', resetGender)
        .catch((err) => console.error(err))

      if (this.$route.fullPath !== '/') {
        this.$router.push('/')
          .catch((err) => console.error(err))
      }
    } else {
      this.showGoHome = false
    }
  }

  private saveProfile () {
    if (this.clientName.length >= 2) {
      this.showSaveProfile = false
      this.$store.dispatch('matrix/saveProfile', this.clientName)
        .catch((err) => console.error(err))
    }
  }

  private showSaveProfileModal () {
    this.showSaveProfile = !this.showSaveProfile
  }

  private toggleSideBar () {
    this.sidebarOpen = !this.sidebarOpen
    if (this.sidebarOpen) {
      this.$store.dispatch('matrix/getProfiles')
        .catch((err) => console.error(err))
    }
  }

  private toggleShoppingCart () {
    this.shoppingCartOpen = !this.shoppingCartOpen
  }
}
